// extracted by mini-css-extract-plugin
var _1 = "TableElement_root__776d0";
export { _1 as "root" }
